@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="content">
  <div class="inputRow">
    <input class="inputBox" [(ngModel)]="criteria.searchTerm" (keyup.enter)="search()" [disabled]="isBusy()"
      placeholder="Search Term"/>
    <select class="orderTypeSelection" [(ngModel)]="criteria.searchOrderType" [disabled]="isBusy()">
      <option value="ALL">All Order Types</option>
      <option value="PARTS_ONLY">Only Parts and Warranty Orders</option>
      <option value="UNITS_ONLY">Only Unit Orders</option>
    </select>
    @if (organizations()) {
      <select [(ngModel)]="criteria.orgUnitId" class="userSelection">
        <option value="">Show All Rep Offices</option>
        @for (organization of organizations(); track organization) {
          <option [value]="organization.code">{{ organization.description }}
          </option>
        }
      </select>
    }
    @if (regions()) {
      <select [(ngModel)]="criteria.region" class="userSelection">
        <option value="">Show All Regions</option>
        @for (region of regions(); track region) {
          <option [value]="region.code">{{ region.description }}</option>
        }
      </select>
    }
    <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="search()">
      <mat-icon class="size-16">search</mat-icon>
      <label class="buttonLabel">Search</label>
    </button>
    <span class="spacer"></span>
    <button class="toolbarButton primary-button" matButton="elevated"
      [disabled]="isBusy() || (searchResults?.data?.length || 0) === 0" (click)="exportToExcel()">
      <mat-icon class="size-16">logout</mat-icon>
      <label class="buttonLabel">Export to Excel</label>
    </button>
  </div>
  <div class="paginatorRow">
    <mat-paginator class="paginator" [pageSizeOptions]="[20, 40, 80]" [pageSize]="20" [showFirstLastButtons]=true></mat-paginator>
    @if (isBusy()) {
      <mat-progress-spinner mode="indeterminate" class="spinner" diameter="24"></mat-progress-spinner>
    }
    @if (warningMessage()) {
      <div class="warningMessage">
        {{ warningMessage() }}
      </div>
    }
  </div>
  <div class="tableWrapper">
    <table mat-table [dataSource]="searchResults" matSort class="paginatedTable bordered-table" (matSortChange)="setSortState()">
      <ng-container matColumnDef="entityId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="entityId">ID</th>
        <td mat-cell *matCellDef="let record">{{ record.entityId }}</td>
      </ng-container>
      <ng-container matColumnDef="projectName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Name</th>
        <td mat-cell *matCellDef="let record">{{ record.projectName }}</td>
      </ng-container>
      <ng-container matColumnDef="associatedEntityId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Associated Quote</th>
        <td mat-cell *matCellDef="let record">{{ record.associatedEntityId }}</td>
      </ng-container>
      <ng-container matColumnDef="salesRep">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Rep Office</th>
        <td mat-cell *matCellDef="let record">{{ record.salesRep }}</td>
      </ng-container>
      <ng-container matColumnDef="responsibility">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sales Rep</th>
        <td mat-cell *matCellDef="let record">{{ record.responsibility }}</td>
      </ng-container>
      <ng-container matColumnDef="outsideSalesRep">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Outside Sales Rep</th>
        <td mat-cell *matCellDef="let record">{{ record.outsideSalesRep }}</td>
      </ng-container>
      <ng-container matColumnDef="includeInForecastIndicator">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Include In Forecast</th>
        <td class="centered-cell" mat-cell *matCellDef="let record">{{ record.includeInForecastIndicator }}</td>
      </ng-container>
      <ng-container matColumnDef="finalExtendedAmount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Quote Amt</th>
        <td class="centered-cell" mat-cell *matCellDef="let record">{{
          record.finalExtendedAmount | currency:
          'USD'
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="totalUnitQty">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Unit Qty</th>
        <td class="centered-cell" mat-cell *matCellDef="let record">{{ record.totalUnitQty }}</td>
      </ng-container>
      <ng-container matColumnDef="statusDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td class="centered-cell" mat-cell *matCellDef="let record">{{ record.statusDescription }}</td>
      </ng-container>
      <ng-container matColumnDef="currentPhase">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Current Phase</th>
        <td mat-cell *matCellDef="let record">{{ record.currentPhase }}</td>
      </ng-container>
      <ng-container matColumnDef="awardProbabilityPercent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Award Probability</th>
        <td mat-cell *matCellDef="let record">{{ record.awardProbabilityPercent }}</td>
      </ng-container>
      <ng-container matColumnDef="lastStatusChangeDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Status Change</th>
        <td mat-cell *matCellDef="let record">{{ record.lastStatusChangeDate | date: 'MM/dd/yyyy' }}</td>
      </ng-container>
      <ng-container matColumnDef="updateTimestamp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Update</th>
        <td mat-cell *matCellDef="let record">{{ record.updateTimestamp | date: 'MM/dd/yyyy' }}</td>
      </ng-container>
      <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Region</th>
        <td mat-cell *matCellDef="let record">{{ record.region }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr (click)="selectOpportunity(row)" class="clickableRow" mat-row [ngClass]="getStatusColor(row)"
      *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
